import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { MessageModel, ConversationModel, AskPrompt } from '../models';

export interface ChatState {
  conversationHistory: ConversationModel[];
  conversation?: ConversationModel;
  askPrompt?: AskPrompt;
  hasSentSetupMessages: boolean;
}

const initialState: ChatState = {
  conversationHistory: [],
  conversation: undefined,
  askPrompt: undefined,
  hasSentSetupMessages: false
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    promptAiChat: (state, action: PayloadAction<AskPrompt>) => {
      state.askPrompt = action.payload;
      return state;
    },
    resetAiPrompt: (state) => {
      state.askPrompt = undefined;
      return state;
    },
    setHasSentSetupMessages: (state) => {
      state.hasSentSetupMessages = true;
      return state;
    },
    addMessage: (state, action: PayloadAction<{ message: MessageModel }>) => {
      if (!state.conversation) {
        state.conversation = {
          date: new Date().toISOString(),
          id: action.payload.message.callSid,
          messages: [action.payload.message]
        }
      } else {
        state.conversation.messages.push(action.payload.message);
      }

      if (!state.conversation.id) state.conversation.id = action.payload.message.callSid;

      return state;
    },
    newChat: (state) => {
      state.conversation = {
        date: new Date().toISOString(),
        messages: []
      }
      return state;
    },
    clearConversation: (state) => {
      if (state.conversation) {
        // check if conversation exists by callsid then push if it doesn't
        if (!state.conversationHistory.find(conv => conv.id === state.conversation?.id))
        state.conversationHistory.push(state.conversation);
      }

      state.conversation = undefined;
      return state;
    },
    loadConversation: (state, action: PayloadAction<{ conversation: ConversationModel }>) => {
      if (state.conversation && !state.conversationHistory.find(conv => conv.id === state.conversation?.id))
        state.conversationHistory.push(state.conversation);

      state.conversation = action.payload.conversation;
      return state;
    },
    deleteConversation: (state, action: PayloadAction<{ conversation: ConversationModel }>) => {
      state.conversationHistory = state.conversationHistory.filter(c => c.id !== action.payload.conversation.id);
      return state;
    },
    setLogoutChat: (state) => {
      state = initialState;
      return state;
    }
  },
});

export const { setHasSentSetupMessages, addMessage, newChat, clearConversation, loadConversation, deleteConversation, setLogoutChat, promptAiChat, resetAiPrompt } = chatSlice.actions;

export const selectConversation = (state: RootState) =>(state.chat.conversation);
export const selectHistory = (state: RootState) =>(state.chat.conversationHistory);
export const selectAskPrompt = (state: RootState) =>(state.chat.askPrompt);

export default chatSlice.reducer;